import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class StaffLicensesTab extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      staff_id: this.props.staff_id,
      code: null,
      only_active: 1,
      expiration: '',
      aircraft_model_id: null,
      type: null,
      staff_licenses: [],
      licence_codes: [
        {value: "CCF", label: this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.opcoesCodigoDeHabilitacao.CCF},
        {value: "CHT", label: this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.opcoesCodigoDeHabilitacao.CHT},
      ],
      aircraft_models: [],
      licence_types: [
        {value: "", label: this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.opcoesHabilitacao.SelecionarTipo},
        {value: "IFRH", label: this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.opcoesHabilitacao.IFRH},
      ]
    };

    //bind específico
    this.add = this.add.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);
    this.activate = this.activate.bind(this);
    this.archive = this.archive.bind(this);
    this.delete = this.delete.bind(this);
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.aircraft_models) && Array.isArray(newProps.staff_licenses) && this.state.loaded === false) {
      this.setState({
        aircraft_models: newProps.aircraft_models,
        staff_licenses: newProps.staff_licenses,
        loaded: true
      });
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      code: this.state.code,
      expiration: this.state.expiration,
      aircraft_model_id: this.state.aircraft_model_id,
      type: this.state.type,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/habilitacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.refreshData();
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // Fetch ativando um item
  activate(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.ativar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/habilitacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if(self.state.only_active === 0){
              self.refreshDataActive(responseJson);
            } else{      
              self.refreshData(responseJson);
            }
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  delete (event) {
    var staff_license_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.deletar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/habilitacao/' + staff_license_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  // Fetch deletando um item
  archive(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.arquivar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/habilitacao/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if(self.state.only_active === 0){
              self.refreshDataActive(responseJson);
            } else{      
              self.refreshData(responseJson);
            }
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/habilitacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_licenses: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcionario/habilitacoes/ativas/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_licenses: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => { 
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tituloHabilitacoes}</h3>
  <hr/>
  <button className="btn btn-sm btn-warning btn-block" onClick={self.state.only_active === 0 ? self.refreshDataActive.bind(self, self.state.staff_licenses) : self.refreshData.bind(self, self.state.staff_licenses)}>{self.state.only_active === 0 ? this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.botaoEsconderArquivoMorto : this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.botaoMostrarArquivoMorto}</button>
  <hr/>
  {(this.state.staff_licenses === null || typeof this.state.staff_licenses === 'undefined') ?  <div><small><em>{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.nenhumaHabilitacaoCadastrada}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.Codigo}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.Frota}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.Tipo}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.CANAC}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.Licenca}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.Vencimento}</th>
          <th className="col-md-1 text-center">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.Status}</th>
          <th className="col-md-1 text-center">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_licenses).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_licenses[k].code}</td>
              <td className="text-center">{self.state.staff_licenses[k].aircraft_model}</td>
              <td className="text-center">{self.state.staff_licenses[k].type}</td>
              <td className="text-center">{self.state.staff_licenses[k].canac}</td>
              <td className="text-center">{self.state.staff_licenses[k].license}</td>
              <td className="text-center">
                {(self.state.staff_licenses[k].expiration_status === 1) ?  <span className="text text-success">{self.state.staff_licenses[k].expiration_str}</span> : <span className="text text-danger">{self.state.staff_licenses[k].expiration_str}</span>}
              </td>
              <td className="text-center">{(self.state.staff_licenses[k].active === 1) ?  <span className="label label-success">{self.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tabela.Arquivado}</span>}</td>
              <td className="text-center">
                {(self.state.staff_licenses[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_licenses[k].id} onClick={self.archive}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_licenses[k].id} onClick={self.activate}><i className="fa fa-fw fa-power-off"></i></button>
                }
                <button className="btn btn-sm btn-danger" value={self.state.staff_licenses[k].id} onClick={self.delete}>
                  <i className="fa fa-fw fa-trash"></i>
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tituloCadastrarHabilitacao}</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.formulario.Codigo}:</label>
        <Select
          className="form-field-name"
          name="code"
          value={this.state.code}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'code')}
          options={this.state.licence_codes}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.formulario.Validade}:</label>
        <InputMask value={this.state.expiration}  maskChar={null} name="expiration" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration')} placeholder="" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.formulario.Frota}:</label>
        <Select
          className="form-field-name"
          name="aircraft_model_id"
          value={this.state.aircraft_model_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
          options={this.state.aircraft_models}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.formulario.Tipo}:</label>
        <Select
          className="form-field-name"
          name="type"
          value={this.state.type}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'type')}
          options={this.state.licence_types}
        />    
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.formulario.botaoSalvarHabilitacao}</button>
  </form>
</div>
    );
  }
}

export default StaffLicensesTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffLicensesTab.js